import PageHeader from "@/components/PageHeader";
import ProfileForm from "@/components/ProfileForm";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert } from "lucide-react";

const FIELDS = [
  { name: "full_name", label: "Fullständigt namn", type: "text", placeholder: "För- och efternamn" },
  { name: "email", label: "E-post", type: "text", placeholder: "namn@exempel.se" },
  { name: "phone", label: "Telefon", type: "text", placeholder: "07x-xxx xx xx" },
  { name: "city", label: "Ort", type: "text", placeholder: "Stad" },
  { name: "address", label: "Adress", type: "text", full: true, placeholder: "Gatuadress (valfritt)" },
];

export default function Profil() {
  const [cid, setCid] = useState("");
  useEffect(() => { api.get("/auth/me").then((r) => setCid(r.data.candidate_id)); }, []);

  return (
    <div>
      <PageHeader
        title="Min profil"
        description="Dina kontaktuppgifter hålls separerade från din matchningsdata och används aldrig i AI-matchningen – bara i slutversionen av ditt CV."
      />
      <Card className="rounded-2xl border-border p-5 mb-6 flex items-center justify-between bg-muted/50">
        <div>
          <div className="text-sm text-muted-foreground">Ditt pseudonyma kandidat-ID</div>
          <div className="font-mono font-semibold text-primary text-lg">{cid}</div>
        </div>
        <Badge variant="secondary" className="rounded-full">Privat</Badge>
      </Card>
      <Card className="rounded-2xl border-amber-300 bg-amber-50 p-4 mb-6 flex items-start gap-3" data-testid="profil-pnr-warning">
        <ShieldAlert className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <p className="text-sm text-amber-900">
          <strong>Dela inte ditt personnummer.</strong> Ange aldrig fullständigt personnummer, bank- eller ID-uppgifter här eller i ditt CV. Arbetsgivare behöver bara namn, kontaktuppgifter och ort i ansökningsskedet.
        </p>
      </Card>
      <ProfileForm fields={FIELDS} endpoint="/profile/identity" wrap={false} loadKey="identity" />
    </div>
  );
}
